
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/[uuid]/select",
      function () {
        return require("private-next-pages/form/[uuid]/select.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/[uuid]/select"])
      });
    }
  